import { RolesItem } from './../Core/Entities/RolesItem'

export const moduleKey = 'user'
export const roles: RolesItem = {
    user: {
        name: 'Usuários',
        key: 'user',
        permissions: {
            read: {
                name: 'Visualizar',
                description: 'Permite visualizar usuários',
                key: 'user:read',
            },
            create: {
                name: 'Cadastrar',
                description: 'Permite cadastrar usuários',
                key: 'user:create',
            },
            edit: {
                name: 'Editar',
                description: 'Permite editar usuários',
                key: 'user:edit',
            },
            link: {
                name: 'Vincular contas Microsoft',
                description:
                    'Permite executar o pré-vínculo em lote e a sincronização com o diretório Microsoft',
                key: 'user:link',
            },
        },
    },
}
